import { render, staticRenderFns } from "./CurrencyForm.vue?vue&type=template&id=65839748&"
import script from "./CurrencyForm.vue?vue&type=script&lang=js&"
export * from "./CurrencyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CurrencyForm.vue"
export default component.exports